export default __webpack_public_path__ + "static/media/fidel.b30a2a64.png";